import { IconTypeEnum } from "@components/Icon/utils/types";

export type NotificationType = {
  /** Text display in the notification toasts */
  text: string;
  /** Link to redirect when the notification is clicked */
  link?: string;
  /** Type of the Notification - with redirection link or without redirection link */
  type?: NotificationTypeEnum; // Optional property for type
  /** Icon to display in the notification */
  icon?: IconTypeEnum;
};

export type NotificationDefaultProps = {
  /** Text display in the notification toasts */
  text: string;
  /** Link to redirect when the notification is clicked */
  link: string;
  /** Icon to display in the notification */
  icon?: IconTypeEnum;
  /** A callback function example to clear the message */
  callback: () => void;
};

export enum NotificationTypeEnum {
  notificationWithLink = "notificationWithLink",
  notificationWithoutLink = "notificationWithoutLink",
  default = "default",
}
